import { PrestationDto } from 'Models/Questions/QuestionDto';

import { ApiDataResponse } from '../ApiData';
import { ProduitDto } from '../Questions/ProduitDto';
import { StoreDto } from '../TravelExpenses/StoreDto';
import { LocalityDto } from '../TravelExpenses/TravelExpenseDto';
import { ProjectDto } from './ProjectDto';

export enum ReponseQuestionTypeDto {
    Comment = 'Comment',
    Number = 'Number',
    Produit = 'Produit',
    MultipleChoicesProduit = 'MultipleChoicesProduit',
    MultipleChoicesPrestation = 'MultipleChoicesPrestation',
    ZipCode = 'ZipCode',
    SingleChoice = 'SingleChoice',
    MultipleChoices = 'MultipleChoices',
}

export interface ReponseCommentPropertiesDto { value: string; }
export interface ReponseNumberPropertiesDto { value: string; }
export interface SetReponseProduitPropertiesDto { user_search?: string; code?: string; }

export interface ReponseChoiceProductDto {
    code: string;//!\\when save configuration
    count: number;
    product?: ProduitDto;//!\\when load configuration
}
export interface SetReponseMultipleChoicesProduitPropertiesDto { user_search?: string; choices_products: ReponseChoiceProductDto[] }
export interface SetReponseMultipleChoicesPrestationPropertiesDto { choices_prestations: ReponseChoiceProductDto[] }

export interface SetReponseZipCodePropertiesDto { value: string; description: string; name: string; }
export interface ReponseSingleChoicePropertiesDto { option_id: string; }
export interface ReponseMultipleChoicesPropertiesDto { option_id_list: Array<string>; }

export enum ReponseContextTypeDto {
    General = 'General',
    Rooms = 'Rooms',
    Walls = 'Walls',
    Stairs = 'Stairs',
    Openings = 'Openings',
    RoomElements = 'RoomElements',
}
export interface ReponseQuestionRoomContextPropertiesDto { room_id: string; }
export interface ReponseQuestionOpeningsContextPropertiesDto { opening_id: string; }
export interface ReponseQuestionRoomElementsContextPropertiesDto { room_element_id: string; }

export interface SetConfigurationReponseDto {
    question_id: string;
    type: ReponseQuestionTypeDto;

    comment_properties?: ReponseCommentPropertiesDto;
    number_properties?: ReponseNumberPropertiesDto;
    single_choice_properties?: ReponseSingleChoicePropertiesDto;
    multiple_choices_properties?: ReponseMultipleChoicesPropertiesDto;
    produit_properties?: SetReponseProduitPropertiesDto;
    multiple_choices_product_properties?: SetReponseMultipleChoicesProduitPropertiesDto;
    multiple_choices_prestation_properties?: SetReponseMultipleChoicesPrestationPropertiesDto;
    zip_code_properties?: SetReponseZipCodePropertiesDto;

    context_type?: ReponseContextTypeDto;
    rooms_context_properties?: ReponseQuestionRoomContextPropertiesDto;
    openings_context_properties?: ReponseQuestionOpeningsContextPropertiesDto;
    room_elements_context_properties?: ReponseQuestionRoomElementsContextPropertiesDto;

    exclude_response_selected?: boolean;
}

export interface SetConfigurationDto {
    total_surface: number;
    opening_count: number;
    room_count: number;
    room_element_count?: number;
    version_parametrage_id: string;
    floor_plan_json: string;
    reponse_list: Array<SetConfigurationReponseDto>;
    store_id_lead: string;
    store_id_delivery: string;
}

// * without is_default
export interface ReponseProduitPropertiesDto { user_search: string; produit: ProduitDto; }

// * without is_default
export interface ReponseChoiceCartDto { code: string; count: number; product?: ProduitDto; prestation?: PrestationDto; }
export interface MultipleChoicesProduitPropertiesDto { user_search: string; choices_products: Array<ReponseChoiceCartDto>; }
export interface MultipleChoicesPrestationPropertiesDto { choices_prestations: Array<ReponseChoiceCartDto>; }

export interface ReponseZipCodePropertiesDto { value: string; locality?: LocalityDto; }

export interface ConfigurationReponseDto {
    readonly question_id: string;
    readonly type: ReponseQuestionTypeDto;

    readonly comment_properties?: ReponseCommentPropertiesDto;
    readonly number_properties?: ReponseNumberPropertiesDto;
    readonly single_choice_properties?: ReponseSingleChoicePropertiesDto;
    readonly multiple_choices_properties?: ReponseMultipleChoicesPropertiesDto;
    readonly produit_properties?: ReponseProduitPropertiesDto;
    readonly multiple_choices_product_properties?: MultipleChoicesProduitPropertiesDto;
    readonly multiple_choices_prestation_properties?: MultipleChoicesPrestationPropertiesDto;
    readonly zip_code_properties?: ReponseZipCodePropertiesDto;

    readonly context_type?: ReponseContextTypeDto;
    readonly rooms_context_properties?: ReponseQuestionRoomContextPropertiesDto;
    readonly openings_context_properties?: ReponseQuestionOpeningsContextPropertiesDto;
    readonly room_elements_context_properties?: ReponseQuestionRoomElementsContextPropertiesDto;

    readonly exclude_response_selected?: boolean;
}

export interface ConfigurationProjetDto {
    projet: ProjectDto;
    touched_by_sellers: boolean;
    is_update_allowed: boolean;
    with_prestation: boolean;
}

export interface ConfigurationDto {
    readonly floor_plan_json: string;
    readonly reponse_list: Array<ConfigurationReponseDto>;
    readonly configuration_projet: ConfigurationProjetDto;
    readonly version_parametrage_id: string;
    readonly projet_store_lead: StoreDto;
    readonly projet_store_delivery: StoreDto;
}

export type GetConfigurationResponse = ApiDataResponse<ConfigurationDto>;
